
import { format } from "date-fns";
import { es } from "date-fns/locale";

interface CalendarHeaderProps {
  days: Date[];
  cellWidth: number;
  labelColumnWidth: number;
}

const CalendarHeader = ({ days, cellWidth }: CalendarHeaderProps) => {
  // Generate month headers based on days
  const monthHeaders: { name: string; days: number; startIndex: number }[] = [];
  let currentMonth = '';
  let dayCount = 0;
  let startIndex = 0;

  days.forEach((day, index) => {
    const monthName = format(day, 'MMMM', { locale: es });
    if (monthName !== currentMonth) {
      if (currentMonth) {
        monthHeaders.push({ name: currentMonth, days: dayCount, startIndex });
      }
      currentMonth = monthName;
      dayCount = 1;
      startIndex = index;
    } else {
      dayCount++;
    }
  });
  
  if (currentMonth) {
    monthHeaders.push({ name: currentMonth, days: dayCount, startIndex });
  }

  return (
    <div className="flex bg-white border-b h-12">
      {monthHeaders.map((month, index) => (
        <div
          key={`${month.name}-${index}`}
          style={{ 
            width: month.days * cellWidth,
            minWidth: month.days * cellWidth,
            maxWidth: month.days * cellWidth
          }}
          className="flex items-center justify-center text-center font-semibold capitalize border-r text-gray-800 text-sm bg-gray-50"
        >
          {month.name}
        </div>
      ))}
    </div>
  );
};

export default CalendarHeader;
